import { render } from "./CertificationPage.vue?vue&type=template&id=73cfe7ab&scoped=true"
import script from "./CertificationPage.vue?vue&type=script&lang=js"
export * from "./CertificationPage.vue?vue&type=script&lang=js"

import "./CertificationPage.vue?vue&type=style&index=0&id=73cfe7ab&scoped=true&lang=css"

import exportComponent from "/home/chris/Documents/HELSINKI/Uni_IFT/truscanWebapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cfe7ab"]])

export default __exports__